type IdiomaSeguranca = "pt" | "en" | "es" | "zh-CN";

const rows: ReadonlyArray<readonly [string, string, string, string, string]> = [
  ["E-mail ou senha inválidos.", "E-mail ou senha inválidos.", "Invalid email or password.", "Correo electrónico o contraseña no válidos.", "电子邮件或密码无效。"],
  ["Muitas tentativas. Aguarde alguns minutos e tente novamente.", "Muitas tentativas. Aguarde alguns minutos e tente novamente.", "Too many attempts. Wait a few minutes and try again.", "Demasiados intentos. Espere unos minutos e inténtelo de nuevo.", "尝试次数过多。请等待几分钟后重试。"],
  ["Origem da requisição não confirmada.", "Origem da requisição não confirmada.", "The request origin could not be verified.", "No se pudo verificar el origen de la solicitud.", "无法验证请求来源。"],
  ["Sessão expirada ou acesso revogado.", "Sessão expirada ou acesso revogado.", "Session expired or access revoked.", "Sesión expirada o acceso revocado.", "会话已过期或访问权限已撤销。"],
  ["Sessão inválida.", "Sessão inválida.", "Invalid session.", "Sesión no válida.", "会话无效。"],
  ["Se houver uma conta para este e-mail, enviaremos as instruções de recuperação.", "Se houver uma conta para este e-mail, enviaremos as instruções de recuperação.", "If an account exists for this email, we will send recovery instructions.", "Si existe una cuenta para este correo, enviaremos las instrucciones de recuperación.", "如果此电子邮件对应账户，我们将发送恢复说明。"],
];

export const TEXTOS_SEGURANCA = rows.reduce<Record<IdiomaSeguranca, Record<string, string>>>(
  (acc, [key, pt, en, es, zh]) => {
    acc.pt[key] = pt;
    acc.en[key] = en;
    acc.es[key] = es;
    acc["zh-CN"][key] = zh;
    return acc;
  },
  { pt: {}, en: {}, es: {}, "zh-CN": {} }
);
